import { FormType } from '../../../form-types';
import { ModafinilQuestionFieldAnswers } from './questions';

export const modafinil: FormType<ModafinilQuestionFieldAnswers> = {
  name: 'Modafinil',
  questions: [
    {
      key: 'modafinil_controlledSubstanceConsent',
      next: {
        condition: {
          'modafinil_controlledSubstanceConsent.do_not_proceed': true
        },
        key: 'generic_didNotConsent',
        els: 'modafinil_mainSymptom'
      }
    },
    'modafinil_mainSymptom',
    {
      key: 'modafinil_sleepConditions2',
      next: {
        switch: [
          {
            condition: { 'modafinil_sleepConditions2.none': true },
            key: 'generic_ineligible'
          },
          {
            condition: { 'modafinil_sleepConditions2.shift_work': true },
            key: 'modafinil_shiftsPerMonth'
          },
          {
            condition: { 'modafinil_sleepConditions2.sleep_apnea': true },
            key: 'modafinil_sleepApneaTreated'
          }
        ],
        els: 'modafinil_symptomDuration'
      }
    },
    {
      key: 'modafinil_shiftsPerMonth',
      next: {
        condition: { 'modafinil_sleepConditions2.sleep_apnea': true },
        key: 'modafinil_sleepApneaTreated',
        els: 'modafinil_symptomDuration'
      }
    },
    {
      key: 'modafinil_sleepApneaTreated',
      next: {
        condition: { 'modafinil_sleepApneaTreated.untreated': true },
        key: 'modafinil_sleepApneaAcknowledgment',
        els: 'modafinil_symptomDuration'
      }
    },
    'modafinil_sleepApneaAcknowledgment',
    'modafinil_symptomDuration',
    'modafinil_symptomFrequency',
    'modafinil_functionalImpact',
    {
      key: 'modafinil_affectedAreas',
      next: {
        condition: { 'modafinil_affectedAreas.other': true },
        key: 'modafinil_affectedAreasOther',
        els: 'modafinil_riskConditions'
      }
    },
    'modafinil_affectedAreasOther',
    {
      key: 'modafinil_riskConditions',
      next: {
        switch: [
          {
            condition: { 'modafinil_riskConditions.allergic_reaction': true },
            key: 'generic_ineligible'
          },
          {
            condition: {
              'modafinil_riskConditions.uncontrolled_bp_or_arrhythmia': true
            },
            key: 'generic_ineligible'
          },
          {
            condition: { 'modafinil_riskConditions.heart_disease': true },
            key: 'generic_ineligible'
          },
          {
            condition: { 'modafinil_riskConditions.stevens_johnson': true },
            key: 'generic_ineligible'
          },
          {
            condition: { 'modafinil_riskConditions.psychiatric_history': true },
            key: 'generic_ineligible'
          },
          {
            condition: { 'modafinil_riskConditions.liver_disease': true },
            key: 'generic_ineligible'
          },
          {
            condition: { 'modafinil_riskConditions.seizure_disorder': true },
            key: 'generic_ineligible'
          },
          {
            condition: {
              'modafinil_riskConditions.stroke_or_head_trauma': true
            },
            key: 'generic_ineligible'
          },
          {
            condition: {
              'modafinil_riskConditions.interacting_medication': true
            },
            key: 'generic_ineligible'
          },
          {
            condition: {
              'modafinil_riskConditions.prior_stimulant_reaction': true
            },
            key: 'generic_ineligible'
          },
          {
            condition: { 'modafinil_riskConditions.dementia': true },
            key: 'generic_ineligible'
          }
        ],
        els: 'modafinil_sleepScheduleConsistency'
      }
    },
    'modafinil_sleepScheduleConsistency',
    'modafinil_sleepHours',
    'modafinil_sleepSymptoms',
    'modafinil_sedatingMedications',
    'modafinil_phq2Interest',
    'modafinil_phq2Mood',
    {
      key: 'modafinil_priorUse',
      next: {
        condition: { 'modafinil_priorUse.yes': true },
        key: 'modafinil_priorSideEffects',
        els: 'modafinil_bloodPressure'
      }
    },
    {
      key: 'modafinil_priorSideEffects',
      next: {
        condition: { 'modafinil_priorSideEffects.yes': true },
        key: 'modafinil_priorSideEffectsDetails',
        els: 'modafinil_bloodPressure'
      }
    },
    'modafinil_priorSideEffectsDetails',
    {
      key: 'modafinil_bloodPressure',
      next: {
        switch: [
          {
            condition: { 'modafinil_bloodPressure.very_high': true },
            key: 'generic_ineligible'
          },
          {
            condition: { 'modafinil_bloodPressure.severely_high': true },
            key: 'generic_ineligible'
          }
        ],
        els: 'modafinil_heartRate'
      }
    },
    {
      key: 'modafinil_heartRate',
      next: {
        condition: { 'modafinil_heartRate.high': true },
        key: 'generic_ineligible',
        els: 'modafinil_sexAssignedAtBirth'
      }
    },
    {
      key: 'modafinil_sexAssignedAtBirth',
      next: {
        condition: { 'modafinil_sexAssignedAtBirth.female': true },
        key: 'modafinil_pregnancyStatus',
        els: 'modafinil_supportingDocuments'
      }
    },
    {
      key: 'modafinil_pregnancyStatus',
      next: {
        condition: { 'modafinil_pregnancyStatus.yes': true },
        key: 'generic_ineligible',
        els: 'modafinil_pregnancyConsent'
      }
    },
    {
      key: 'modafinil_pregnancyConsent',
      next: {
        condition: { 'modafinil_pregnancyConsent.non_consent': true },
        key: 'generic_didNotConsent',
        els: 'modafinil_supportingDocuments'
      }
    },
    {
      key: 'modafinil_supportingDocuments',
      next: {
        condition: { 'modafinil_supportingDocuments.yes': true },
        key: 'modafinil_supportingDocumentsUpload2',
        els: 'modafinil_additionalQuestions'
      }
    },
    'modafinil_supportingDocumentsUpload2',
    'modafinil_additionalQuestions',
    {
      key: 'modafinil_treatmentConsent',
      next: {
        condition: { 'modafinil_treatmentConsent.do_not_continue': true },
        key: 'generic_didNotConsent',
        els: 'generic_complete'
      }
    },
    'generic_complete',
    'generic_ineligible',
    'generic_didNotConsent'
  ]
};

export default modafinil;
